import React, { useEffect, useState } from "react";
import firebase from "../../config/fbConfig";
import "firebase/storage";
import ExportButton from "../instructions/ExportButton";
import TemplatePreview from "../layout/TemplatePreview";

async function GetTemplate(clientId) {
  return await firebase
    .firestore()
    .collection("templates")
    .doc(clientId)
    .get()
    .then(function (doc) {
      return doc.data();
    });
}

function Template(props) {
  const clientId = props.match.params.id;
  const [template, setTemplate] = useState({});
  var templateLength = Object.keys(template).length;
  useEffect(() => {
    GetTemplate(clientId)
      .then((data) =>
        setTemplate({
          textColor: data.textColor,
          backgroundColor: data.backgroundColor,
          dropdown: data.dropdown,
          logo: data.logo,
          logoColor: data.logoColor,
          logoWidth: data.logoWidth,
          watermarkHidden: data.watermarkHidden
        })
      )
      .catch((error) => console.log(error));
  }, []);
  return templateLength === 0 ? (
    <div>
        Loading...
        <br /><br />
        <small>If you have read this sentence. Try refreshing the page.</small>
    </div>
  ): (
    <div>
      <TemplatePreview template={template} />
      <br /><br />
      <div className="template-cta">
        <div></div>
        <ExportButton className=""/>
        <a className="bmc-button template-bmc" target="_blank" href="https://www.buymeacoffee.com/jameseastlondon">
          <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"/>
          <span className="bmc-span">Buy James<br/>a coffee?</span>
        </a>
      </div>
    </div>
  );
}

export default Template;
